/* global DetectUserAgent */
import { useSelector } from "react-redux";

import { useFilestackActions } from "store/FilestackSlice";

const useFilestackView = () => {
  const GetHandleView = useSelector((state) => state.FilestackSlice.handleView);

  const { changeValue, resetValue } = useFilestackActions();
  const isFbInAppBrowser = DetectUserAgent.isFBInAppBrowser();

  const setHandleViewStorage = (value) => {
    if (isFbInAppBrowser) {
      sessionStorage.setItem("filestackModal", value);
    }
    changeValue(value);
  };

  const resetValueToStorage = () => {
    if (isFbInAppBrowser) {
      sessionStorage.removeItem("filestackModal");
    }
    resetValue();
  };

  return { GetHandleView, setHandleViewStorage, resetValueToStorage };
};

export default useFilestackView;
